/* eslint-disable */

export default `
// -----------------------------------------------------------------------------
//
// Easing functions, adapted from JavaScript implementations from
// https://github.com/AndrewRayCode/easing-utils by Andy Ray.
//
// -----------------------------------------------------------------------------

#ifndef PI
PI = 3.14159265358979;
#endif

float linear(float t) {
    return t;
}

float easeInSine(float t) {
    return 1.0 - cos((t * PI) / 2.0);
}

float easeOutSine(float t) {
    return sin((t * PI) / 2.0);
}

float easeInOutSine(float t) {
    return -0.5 * ( cos( PI * t ) - 1.0 );
}

float easeInQuad(float t) {
    return t * t;
}

float easeOutQuad(float t) {
    return t * ( 2.0 - t );
}

float easeInOutQuad(float t) {
    return t < 0.5 ? 2.0 * t * t : - 1.0 + ( 4.0 - 2.0 * t ) * t;
}

float easeInCubic(float t) {
    return t * t * t;
}

float easeOutCubic(float t) {
    float t1 = t - 1.0;
    return t1 * t1 * t1 + 1.0;
}

float easeInOutCubic(float t) {
    return t < 0.5 ? 4.0 * t * t * t : ( t - 1.0 ) * ( 2.0 * t - 2.0 ) * ( 2.0 * t - 2.0 ) + 1.0;
}

float easeInQuart(float t) {
    return t * t * t * t;
}

float easeOutQuart(float t) {
    float t1 = t - 1.0;
    return 1.0 - t1 * t1 * t1 * t1;
}

float easeInOutQuart(float t) {
    float t1 = t - 1.0;
    return t < 0.5 ? 8.0 * t * t * t * t : 1.0 - 8.0 * t1 * t1 * t1 * t1;
}

float easeInQuint(float t) {
    return t * t * t * t * t;
}

float easeOutQuint(float t) {
    float t1 = t - 1.0;
    return 1.0 + t1 * t1 * t1 * t1 * t1;
}

float easeInOutQuint(float t) {
    float t1 = t - 1.0;
    return t < 0.5 ? 16.0 * t * t * t * t * t : 1.0 + 16.0 * t1 * t1 * t1 * t1 * t1;
}

float easeInExpo(float t) {
    if (t == 0.0) return 0.0;
    return pow( 2.0, 10.0 * ( t - 1.0 ) );
}

float easeOutExpo(float t) {
    if(t == 1.0) return 1.0;
    return ( -pow( 2.0, -10.0 * t ) + 1.0 );
}

float easeInOutExpo(float t) {
    if (t == 0.0 || t == 1.0) return t;
    float scaledTime = t * 2.0;
    float scaledTime1 = scaledTime - 1.0;
    if (scaledTime < 1.0) return 0.5 * pow( 2.0, 10.0 * ( scaledTime1 ) );
    return 0.5 * ( -pow( 2.0, -10.0 * scaledTime1 ) + 2.0 );
}

float easeInCirc(float t) {
    float scaledTime = t / 1.0;
    return -1.0 * ( sqrt( 1.0 - scaledTime * t ) - 1.0 );
}

float easeOutCirc(float t) {
    float t1 = t - 1.0;
    return sqrt( 1.0 - t1 * t1 );
}

float easeInOutCirc(float t) {
    float scaledTime = t * 2.0;
    float scaledTime1 = scaledTime - 2.0;
    if (scaledTime < 1.0) return -0.5 * ( sqrt( 1.0 - scaledTime * scaledTime ) - 1.0 );
    return 0.5 * ( sqrt( 1.0 - scaledTime1 * scaledTime1 ) + 1.0 );
}
`
